import { render, staticRenderFns } from "./ProductMarketData.vue?vue&type=template&id=093f2036&scoped=true&"
import script from "./ProductMarketData.vue?vue&type=script&lang=ts&"
export * from "./ProductMarketData.vue?vue&type=script&lang=ts&"
import style0 from "./ProductMarketData.vue?vue&type=style&index=0&id=093f2036&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093f2036",
  null
  
)

export default component.exports